import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {FormBuilder} from '@angular/forms';

@Component({
  selector: 'delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.less']
})
export class DeleteDialogComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
  }

  onConfirm() {
    if (this.data.name?.length === 0) {
      return;
    }
    this.isLoading = true;

    // let finalData: any
    // if(this.data.type === 'zone'){
    //   this.data = {...this.data, 
    //     name: this.data.name,
    //     gateway: this.data.gateway
    //   }
    // }

    this.data.function(this.data).subscribe(
      result => {
        this.dialogRef.close(this.data);
      }, complete => {
        this.isLoading = false;
      }
    )
  }

}
